export default __webpack_public_path__ + "static/media/home-travel-agency-packages-img01.f1fe71cb.jpg";